import { useEffect, useRef } from "react";
import Stats from "stats.js";
import './fps.css';

export default function Fps(props) {
    const statsRef = useRef(null);

    useEffect(() => {
        const existingStats = document.getElementById("fps-stats");
        if (!existingStats) {
            statsRef.current = new Stats();
            statsRef.current.showPanel(0);

            const statsElement = statsRef.current.dom;
            statsElement.id = "fps-stats";
            statsElement.style.transition = "0.6s";
            statsElement.style.left = "-30%"; 
            document.body.appendChild(statsElement);

            const animate = () => {
                statsRef.current.begin();
                statsRef.current.end();
                requestAnimationFrame(animate);
            };

            animate();
        }
        if (props.showfps) {
            document.getElementById("fps-stats").style.left = "0%";
        } else {
            document.getElementById("fps-stats").style.left = "-30%";
        }

        return () => {
            const existingStats = document.getElementById("fps-stats");
            if (existingStats) {
                document.body.removeChild(existingStats);
            }
        };
    }, [props.showfps]);

    return null;
}
